import React from 'react';
import PropTypes from 'prop-types';
import ButtonIcon from '../../ButtonIcon';

const VIEW_TYPES = {
  day: 'day',
  week: 'week',
  month: 'month',
  agenda: 'agenda'
};

const CalendarToolBar = ({
  month,
  view,
  onNavigate,
  label,
  daysInView,
  showPreviousButton,
  showNextButton,
  ...props
}) => (
  <div className='calendar__toolbar' {...props}>
    {view === VIEW_TYPES.week && (
      <span className='calendar__toolbar__month'>{month}</span>
    )}
    <div className='calendar__toolbar__navigation-bar'>
      {showPreviousButton && (
        <ButtonIcon
          iconVariant='arrow-left'
          onClick={() => onNavigate('PREV')}
          data-testid='previous-button'
        />
      )}
      <div className='calendar__toolbar__dates'>
        {view === VIEW_TYPES.week ? (
          daysInView.map(day => (
            <div key={day.date}>
              <p>{day.day}</p>
              <h3 className='calendar__toolbar__day'>{day.date}</h3>
            </div>
          ))
        ) : (
          <h3>{label}</h3>
        )}
      </div>
      {showNextButton && (
        <ButtonIcon
          iconVariant='arrow-right'
          onClick={() => onNavigate('NEXT')}
          data-testid='next-button'
        />
      )}
    </div>
  </div>
);

CalendarToolBar.propTypes = {
  month: PropTypes.string,
  view: PropTypes.oneOf(Object.keys(VIEW_TYPES)).isRequired,
  label: PropTypes.string,
  daysInView: PropTypes.array,
  showPreviousButton: PropTypes.bool,
  showNextButton: PropTypes.bool,
  onNavigate: PropTypes.func.isRequired
};

export default CalendarToolBar;
